var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.93,
    height: 132.15,
    viewBox: "0 0 139.93 132.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.51,58.77a3.87,3.87,0,0,1,0-5.49l2.75-2.75-2.75-2.75a3.89,3.89,0,0,1,0-5.5h0a3.87,3.87,0,0,1,5.49,0L42.75,45l2.75-2.75a3.89,3.89,0,0,1,5.5,5.5l-2.75,2.75L51,53.28a3.89,3.89,0,1,1-5.5,5.49L42.75,56,40,58.77A3.89,3.89,0,0,1,34.51,58.77Zm70.9-16.49a3.87,3.87,0,0,0-5.49,0L97.17,45l-2.75-2.75a3.89,3.89,0,0,0-5.5,0h0a3.89,3.89,0,0,0,0,5.5l2.75,2.75-2.75,2.75a3.89,3.89,0,1,0,5.5,5.49L97.17,56l2.75,2.75a3.88,3.88,0,0,0,5.49-5.49l-2.75-2.75,2.75-2.75A3.89,3.89,0,0,0,105.41,42.28ZM96.06,82.76a3.89,3.89,0,0,0-5.5,0l-5,5-5-5a3.89,3.89,0,0,0-5.5,0l-5,5-5-5a3.89,3.89,0,0,0-2.75-1.14,3.85,3.85,0,0,0-2.74,1.14l-5,5-5-5a3.87,3.87,0,0,0-5.49,0l-7.79,7.77A3.89,3.89,0,1,0,41.62,96l5-5,5,5a3.89,3.89,0,0,0,5.5,0l5-5,5,5a3.89,3.89,0,0,0,5.5,0l5-5,5,5a3.87,3.87,0,0,0,5.49,0l5-5,5,5a3.88,3.88,0,0,0,5.5-5.48ZM139.93,31.1v70a31.1,31.1,0,0,1-31.1,31.09H31.09A31.09,31.09,0,0,1,0,101.06v-70A31.09,31.09,0,0,1,31.09,0h77.74A31.1,31.1,0,0,1,139.93,31.1Zm-7.78,0A23.33,23.33,0,0,0,108.83,7.77H31.09A23.33,23.33,0,0,0,7.77,31.1v70a23.32,23.32,0,0,0,23.32,23.32h77.74a23.32,23.32,0,0,0,23.32-23.32Z",
    fill: "#624de3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.fd07563b355fcfd7fa6910b923db0400.svg";
export { ForwardRef as ReactComponent };